import {
  dateOperating
} from '@/cllib/tools'

import {
  invoicingGetData
} from '@/api/api'

const state = {
  relatedinvoicing: [],
  relatedinvoicingLoading: false,
  upadteRelatedinvoicing: {}
}

const getters = {
  relatedinvoicing: state => state.relatedinvoicing,
  relatedinvoicingLoading: state => state.relatedinvoicingLoading,
  upadteRelatedinvoicing: state => state.upadteRelatedinvoicing
}

const actions = {
  loadRelatedinvoicing ({ dispatch, getters }) {
    dispatch('setUpadteRelatedinvoicing', {})
    if (!getters.chooseErrorInvoicing.id) {
      dispatch('setRelatedinvoicing', [])
      return
    }
    dispatch('setRelatedinvoicingLoading', true)
    let chooseErrorInvoicingCollectTime = getters.chooseErrorInvoicingCollectTime
    let parm = {
      noPage: 1,
      mergeIdnull: 1,
      oilId: getters.chooseErrorInvoicing.oilId,
      gasId: getters.chooseErrorInvoicing.gasId,
      collectTime: dateOperating.computeDay({days: -5, date: chooseErrorInvoicingCollectTime, format: 'yy-mm-dd'}),
      endTime: dateOperating.computeDay({days: 5, date: chooseErrorInvoicingCollectTime, format: 'yy-mm-dd'})
    }
    invoicingGetData(parm).then((data) => {
      data.forEach((item) => {
        item.outVolume = parseInt(item.outVolume)
        item.collectTimeS = item.collectTime ? item.collectTime.slice(5, 16) : '--'
      })
      dispatch('setRelatedinvoicing', data)
      dispatch('setRelatedinvoicingLoading', false)
    }).catch((e) => {
      dispatch('setRelatedinvoicingLoading', false)
    })
  },
  updateRelatedInvoicingOne ({ commit, dispatch }, data) {
    commit('updateRelatedInvoicingOne', data)
    dispatch('updateErrorInvoicingOne', data)
  },
  updateRelatedInvoicingError ({ commit, dispatch }, data) {
    commit('updateRelatedInvoicingError', data)
    dispatch('updateErrorInvoicingError', data)
  },
  setRelatedinvoicing ({ commit }, data) {
    commit('setRelatedinvoicing', data)
  },
  setRelatedinvoicingLoading ({ commit }, data) {
    commit('setRelatedinvoicingLoading', data)
  },
  setUpadteRelatedinvoicing ({ commit }, data) {
    commit('setUpadteRelatedinvoicing', data)
  }
}

const mutations = {
  setUpadteRelatedinvoicing (state, data) {
    state.upadteRelatedinvoicing = data
  },
  setRelatedinvoicing (state, data) {
    state.relatedinvoicing = data
  },
  setRelatedinvoicingLoading (state, data) {
    state.relatedinvoicingLoading = data
  },
  updateRelatedInvoicingError (state, id) {
    state.relatedinvoicing.forEach((item) => {
      if (item.id === id) {
        item.isError = false
        item.errorText = item.isError ? '异常' : ''
        state.upadteRelatedinvoicing['key_' + item.id] = {
          id: item.id,
          isError: item.isError ? 1 : 0,
          inVolume: item.inVolume,
          replaceUpdate: 0
        }
      }
    })
  },
  updateRelatedInvoicingOne (state, data) {
    let hisInTime = data.his.isDel === 0 && data.his.inTime ? dateOperating.formatDate({date: data.his.inTime, format: 'stamps'}) : null
    let newInTime = data.new.isDel === 0 && data.new.inTime ? dateOperating.formatDate({date: data.new.inTime, format: 'stamps'}) : null
    let change = false
    state.relatedinvoicing.forEach((item) => {
      change = false
      let startTime = dateOperating.computeDay({days: -1, date: item.collectTime, format: 'stamps'})
      let endTime = dateOperating.computeDay({days: 0, date: item.collectTime, format: 'stamps'})
      if (hisInTime && (hisInTime > startTime || hisInTime === startTime) && hisInTime < endTime && item.gasTankId === data.his.gasTankId) {
        item.inVolume = item.inVolume - data.his.inVolume
        item.inVolume = item.inVolume < 10 && item.inVolume > -10 ? 0 : item.inVolume
        change = true
      }
      if (newInTime && (newInTime > startTime || newInTime === startTime) && newInTime < endTime && item.gasTankId === data.new.gasTankId) {
        item.inVolume = item.inVolume + data.new.inVolume
        change = true
      }
      if (change) {
        item.nowErrorVolume = parseInt(item.startInventory - item.outVolume + item.inVolume - item.endInventory)
        state.upadteRelatedinvoicing['key_' + item.id] = {
          id: item.id,
          nowErrorVolume: item.nowErrorVolume,
          inVolume: item.inVolume,
          replaceUpdate: 0
        }
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/invoicing_check/related_invoicing.js